// REACT
import { useEffect } from 'react';

// YARN
import { toast } from 'react-toastify';

// SERVICE
import DataGridGroundTypeEffects from './DataGridGroundTypeEffects';
import useToggleSwitch from 'utils/hooks/useToggleSwitch';
import { getCultures } from 'services/API/Cooperative';

const GroundTypeEffectsStructure = ({
  groundTypes,
  cultures,
  ownerId,
  setCooperativeCultures,
  from,
}) => {
  const { isOrganic } = useToggleSwitch(from, 'groundTypesEffects', () => {}, ownerId, null, null);

  const fetchCooperativeCultures = (isOrganic, ownerId) => {
    if (!ownerId) {
      ownerId = Number(localStorage.getItem('cooperative'));
    }
    getCultures(ownerId, isOrganic, 'rotation')
      .then((res) => {
        setCooperativeCultures(res.data.data);
      })
      .catch((err) => {
        toast.error(err.data);
      });
  };

  useEffect(() => {
    fetchCooperativeCultures(isOrganic, ownerId);
  }, []);

  return (
    <DataGridGroundTypeEffects
      from={from}
      cultures={cultures?.filter((culture) => culture.isCustomized === true)}
      ownerId={ownerId}
      refreshData={fetchCooperativeCultures}
      groundTypes={groundTypes}
    />
  );
};

export default GroundTypeEffectsStructure;
